import { render, staticRenderFns } from "./BodyWedding.vue?vue&type=template&id=38229e0c&scoped=true"
import script from "./BodyWedding.vue?vue&type=script&lang=js"
export * from "./BodyWedding.vue?vue&type=script&lang=js"
import style0 from "./BodyWedding.vue?vue&type=style&index=0&id=38229e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38229e0c",
  null
  
)

export default component.exports